import React from "react"
import { graphql } from "gatsby"
import GatsImg from "gatsby-image"
import Headermenu from "../containers/RealestatePage1/HeaderMenuBS"
import Footer from "../containers/RealestatePage1/Footer"
import GlobalStyle from "../containers/RealestatePage1/Common/global-styles"
import { Container } from "react-bootstrap"
import Fonts from "../containers/RealestatePage1/Common/fonts"
import "../components/layout.css"
import SEO from "../components/seo"
import {
  contentWrapper,
  content,
  image,
} from "../containers/RealestatePage1/Common/markdownStyle.module.css"

function SubmitProperty({ data }) {
  console.log(data)
  const { html } = data.markdownRemark
  const { img } = data.markdownRemark.frontmatter

  return (
    <>
      <Fonts />
      <GlobalStyle />
      <main>
        <SEO
          title="Submit Property"
          description="We can help you sell your property in no time"
        />
        <Headermenu home={false} />

        <div className={contentWrapper} id="submitSection">
          <article>
            <Container>
              <div className={content}>
                <GatsImg fluid={img.childImageSharp.fluid} />
                <br />
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </div>
            </Container>
          </article>
        </div>
      </main>
      <Footer />
    </>
  )
}
export const query = graphql`
  query SellerQuery {
    markdownRemark(frontmatter: { title: { eq: "seller's guide" } }) {
      id
      html
      frontmatter {
        heading
        img {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`

export default SubmitProperty
